const ShipperConsigneeDetailsCard = ({
  companyName = false,
  city = false,
  state = false,
  zip = false,
  country = false,
  address = false,
}) => {
  return (
    <>
      {companyName ? (
        <>
          <span>{companyName}</span>
          <br />
        </>
      ) : (
        <></>
      )}
      <span>
        {addressLineGenerator(address)}
        {addressLineGenerator(city)}
        {addressLineGenerator(state)}
        {addressLineGenerator(zip)}
        {addressLineGenerator(country, '.', false)}
      </span>
    </>
  );
};

export default ShipperConsigneeDetailsCard;

const addressLineGenerator = (value = false, suffix = ',', space = true) =>
  value ? `${value}${suffix}${space ? ' ' : ''}` : '';
